import React, { useRef, useEffect, useState } from "react";
import "./marketPlace.css";
import memetv from "../../assets/images/rewards.svg";
import booster from "../../assets/images/boost-tap.png";
import ligthing from "../../assets/images/lighting.png";
import booster3 from "../../assets/images/threex.png";
import booster2 from "../../assets/images/2booster.png";
import cancelIcon from "../../assets/Task/cancelicon.svg";
import cancelbtn from "../../assets/Task/cancelicon1.png";
import { getUserDetails1, purchaseBooster } from "../../apis/user";
import useUserInfo from "../../Hooks/useUserInfo";
import { UserDeatils } from "../../apis/user";
import { useAudio } from "../../Providers/AudioProvider";
import Tv from "../Tv/Tv";
import { logPageView } from "../../components/analytics";
import { EarlyMintWatchPoint, formatNumber, Images } from "../../helpers/helpers";
import logo from "../../assets/images/meme-logo.svg";
import Spinner from "../Streak/Spinner";
import energy from "../../assets/images/marketenergy.svg";
import Swal from "sweetalert2";
import { purchaseIplBooster } from "../../apis/iplBattle";

const MarketPlace = (props) => {
const twoxAmount = 100;
const threexAmount = 200;
const fourxAmount = 250;
const fivexAmount = 300;
const RallyAmount = 25000; 
const squadMultiplierAmount = 4200;
const comboChaninAmout = 500;
  const { userDetails, watchScreen, updatewatchScreenInfo, updateUserInfo } =
    useUserInfo();
  const userId = userDetails?.userDetails?.telegramId;
  const [showPopup, setShowPopup] = useState(false);
  const [selected, setSelected] = useState({});

  const [totalReward, setTotalReward] = useState();
  const [count, setCount] = useState(1);
  const [err, setErr] = useState("");
  const [isLoading, setisLoading] = useState(false);
  const [isFirst, setIsFirst] = useState(false);
  const timeoutRef = useRef(null); // To store the timeout ID
  const playClick = useAudio();
  const [activeSection, setActiveSection] = useState("section1");

  const handleClick1 = () => {
    playClick();
    setCount(count + 1);
  };
  useEffect(() => {
    logPageView("MarketPlace ", "Market place");
  }, []);
  const isEarlyUserForWatchMinting =
    process.env.REACT_APP_IS_TOKEN_MINT_PER_SEC_TO_ONE === "true" &&
    (userDetails?.earlyUsersLimitReached ??
      userDetails?.user?.earlyUsersLimitReached ??
      userDetails?.userData?.earlyUsersLimitReached ??
      false);

  const isEarlyUserForTapMinting =
    process.env.REACT_APP_IS_TOKEN_MINT_PER_TAP_TO_ONE === "true" &&
    (userDetails?.earlyUsersLimitReached ??
      userDetails?.user?.earlyUsersLimitReached ??
      userDetails?.userData?.earlyUsersLimitReached ??
      false);

  useEffect(() => {
    if (props?.isMarketOpen) {
      localStorage.setItem(
        `pointDetails_${userId}`,
        JSON.stringify({
          tapPoints: 0,
          watchSec: 0,
          boosterPoints: 0,
          booster: [0],
          count: 0,
        })
      );
    }
  }, [props?.isMarketOpen]);
  const goToThePage = (component, name) => {
    props?.setMarketOpen(false);
    updateUserInfo((prev) => ({
      ...prev,
      currentComponent: component,
      currentComponentText: name,
      lastComponent: userDetails.currentComponent,
      lastComponentText: userDetails.currentComponentText,
      centerCount: userDetails.centerCount + 1,
      isMenu: false,
    }));
  };

  useEffect(() => {
    updateUserInfo((prev) => ({
      ...prev,
      isLoading: false,
    }));

    if (!isFirst && watchScreen?.updatedWatchPoints > 0) {
      setTotalReward(watchScreen.totalReward);
      setIsFirst(true);
    }
  }, [watchScreen, isFirst]);

  useEffect(() => {
    const getUserDetails = async (data) => {
      const userDetails = await UserDeatils(data);

      updateUserInfo((prev) => ({
        ...prev,
        userDetails: userDetails?.user,
      }));

      updatewatchScreenInfo((prev) => ({
        ...prev,
        boostersList: userDetails?.user?.boosters,
      }));
    };
    const data1 = {
      name: userDetails?.userDetails?.name,
      telegramId: String(userDetails?.userDetails?.telegramId),
    };

    getUserDetails(data1);
  }, []);
  const handleClick2 = () => {
    playClick();
    if (count === 1) {
    } else {
      setCount(count - 1);
    }
  };

  const getDetails = async (data) => {
    const userDetails = await UserDeatils(data);
    setTotalReward(userDetails?.user?.balanceRewards);
    updateUserInfo((prev) => ({
      ...prev,
      userDetails: userDetails?.user,
    }));

    updatewatchScreenInfo((prev) => ({
      ...prev,
      boostersList: userDetails?.user?.boosters,
      totalReward: userDetails?.user?.balanceRewards,
    }));

    return userDetails;
  };

  const getUserDetails = () => {
    const data = {
      name: userDetails.userDetails?.name,
      telegramId: userDetails?.userDetails?.telegramId,
    };

    const res = getDetails(data);
  };

  const PurchaseEnergy = async (boosterPoints, booster) => {
    updateUserInfo((prev) => ({
      ...prev,
      isLoading: true,
    }));

    const data = {
      boosterPoints: boosterPoints,
      booster: booster,
      boosterCount: 1,
    };

    const Boosters = await purchaseBooster(data);

    if (Boosters?.energy) {
      localStorage.setItem(`energy_${userId}`, 5000);
      Swal.fire({
        text: `ENERGY IS REFILLED SUCCESSFULLY`,
        icon: "success",
        closeOnClickOutside: false,
        confirmButtonText: "Okay",
      }).then((confirm) => {
        if (confirm) {
          updateUserInfo((prev) => ({
            ...prev,
            isLoading: false,
          }));
        }
      });
    } else {
      Swal.fire({
        text: `Not Enough Total tokens!`,
        icon: "error",
        closeOnClickOutside: false,
        confirmButtonText: "Okay",
      }).then((confirm) => {
        if (confirm) {
          setCount(1);
          setShowPopup(false);
          setisLoading(false);
        }
      });
    }
  };
  const purchaseCards = async () => {
    playClick();
    setisLoading(true);

    const data = {
      boosterPoints: String(selected.price * count),
      booster: selected.booster,
      boosterCount: count,
    };
    const Boosters = selected?.ipl
      ? await purchaseIplBooster(data)
      : await purchaseBooster(data);

    if (Boosters?.message) {
      Swal.fire({
        text: `Booster Purchased Successfully`,
        icon: "success",
        closeOnClickOutside: false,
        confirmButtonText: "Okay",
      }).then((confirm) => {
        if (confirm) {
          setisLoading(false);
          setShowPopup(false);
          setCount(1);
          getUserDetails();
        }
      });
    } else {
      // setShowPopup(true);
      // setErr("Not Enough Total tokens!");
      Swal.fire({
        text: `Not Enough Total tokens!`,
        icon: "error",
        closeOnClickOutside: false,
        confirmButtonText: "Okay",
      }).then((confirm) => {
        if (confirm) {
          setCount(1);
          setShowPopup(false);
          setisLoading(false);
        }
      });
      // timeoutRef.current = setTimeout(() => {
      //   setCount(1);
      //   setShowPopup(false);
      //   setisLoading(false);
      //   setErr("");
      // }, 2500);
    }
  };

  const closePopUp = () => {
    playClick();
    clearTimeout(timeoutRef.current);
    setCount(1);
    setErr("");
    setShowPopup(false);
  };
  const getUserDetailsOnly = async () => {
    let userDetails1;
    try {
      userDetails1 = await getUserDetails1(
        userDetails?.userDetails?.telegramId
      );
    } catch (error) {
      console.error("Error in updating or fetching user details:", error);
    }
    // Update state after both async calls are completed
    if (userDetails) {
      updateUserInfo((prev) => ({
        ...prev,
        userDetails: userDetails1,
      }));
      updatewatchScreenInfo((prev) => ({
        ...prev,
        boostersList: userDetails1?.boosters,
        totalReward: userDetails1?.balanceRewards,
        tapPoints: 0,
        booster: false,
        boosterSec: 0,
        boosterPoints: 0,
        boosterDetails: {},
        watchSec: 0,
      }));
    }
    return userDetails;
  };
  const toogleMenu = () => {
    playClick();
    if (!watchScreen.booster) {
      const data = getUserDetailsOnly().then(() => {
        updateUserInfo((prev) => ({
          ...prev,
          isPlay: false,
          currentComponent: Tv,
          currentComponentText: "TVPage",
          lastComponent: userDetails?.userDetails.currentComponent,
          lastComponentText: userDetails?.userDetails.currentComponentText,
          isMenu: false,
          menuCount: userDetails?.userDetails?.menuCount + 1,
        }));
        // goToThePage(Battle, "BattlePage");
      });
    } else {
      goToThePage(Tv, "TVPage");
    }
  };
  return (
    <div className="info-img menupointer">
      <img
        onClick={() => {
          toogleMenu();
          // console.log("hihihi");
        }}
        src="https://d1ccopf5cw1hft.cloudfront.net/s3data/cancelicon.svg"
        className="cancel-imgpoints"
        style={{ cursor: "pointer" }}
      />

      <div
        className="menupointer "
        style={{
          height: "100%",
          width: "100%",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          marginTop: "3%",
          flexDirection: "column",
          pointerEvents: "all",
        }}
      >
        <div className="market-place">
          <div className="market">
            <div className="bg-market">
              <h2 className="welcome-text mb15 text-center">Market place</h2>
              <hr />
              <div className="row mt5">
                <div className="display-flex">
                  <div className="col-7">
                    <p className="rewards mb0"> Total Rewards</p>
                  </div>
                  <div className="col-5 text-right market-color">
                    <p className="mb0 market-points">
                      <img
                        style={{ width: "15%" }}
                        src={Images?.coinLogo}
                      />{" "}
                      {formatNumber(totalReward)}
                      {/* 13241543 */}
                    </p>
                  </div>
                </div>
              </div>
            </div>
            <div
            // style={{
            //   maxHeight: "55vh",
            //   overflow: "scroll",
            // }}
            >
              {/* <div className="row  cheap-stuff mpb15">
                <div className="col-2">
                  <img src={energy} alt="Login streak icon" className="image" />
                </div>
                <div className="col-7 stuff-text">
                  <h4 style={{ color: "rgba(0, 174, 239, 1)" }}>
                    BUY FULL Energy
                  </h4>
                  <h4 className="mb0 market-color dflex">
                    <img className="mr5" src='https://d1ccopf5cw1hft.cloudfront.net/s3data/coinlogo.png' /> 3000
                  </h4>{" "}
                </div>
                <div className="col-3">
                  <button className="btn-card"   onClick={() => {
                          playClick();
                          PurchaseEnergy(3000,"energy")
                        }}>BUY</button>
                </div>
              </div> */}

              <div className="mb-2 dis-refer mt-2">
                <button
                  className={`btn-${
                    activeSection === "section1"
                      ? "primary1"
                      : "outline-primary1"
                  } me-2`}
                  onClick={() => setActiveSection("section1")}
                >
                  UFW BOOSTERS
                </button>
                <button
                  className={`btn-${
                    activeSection === "section2"
                      ? "primary1"
                      : "outline-primary1"
                  }`}
                  onClick={() => setActiveSection("section2")}
                >
                  BOOSTERS
                </button>
              </div>

              {activeSection === "section1" && (
                <div className="scrollable-mrkt">
                  <div className="row ipl0 mt15">
                    <div className="col-6">
                      <div className="market-card p5">
                        <div className="market-pick text-center">
                          <img
                            src={Images?.twoXIplMarket}
                            className="booster-margin"
                          />
                          <div className="row">
                            <h4 className="mb0 market-color flex">
                              <img
                                className="mr5 wd-25"
                                src={Images?.coinLogo}
                              />{" "}
                              {twoxAmount *
                                (isEarlyUserForWatchMinting
                                  ? EarlyMintWatchPoint
                                  : userDetails?.userDetails?.level)}
                            </h4>
                          </div>
                        </div>
                        <div className="p10">
                          <button
                            onClick={() => {
                              playClick();
                              setShowPopup(true);
                              setSelected({
                                booster: "2x",
                                ipl: true,
                                img: Images?.twoXIplMarket,
                                price:
                                  twoxAmount *
                                  (isEarlyUserForWatchMinting
                                    ? EarlyMintWatchPoint
                                    : userDetails?.userDetails?.level),
                              });
                            }}
                            type="button"
                            className="btn-card"
                          >
                            BUY
                          </button>
                        </div>
                      </div>
                    </div>
                    <div className="col-6">
                      <div className="market-card p5">
                        <div className="market-pick text-center">
                          <img
                            src={Images?.thirdXIplMarket}
                            className="booster-margin"
                          />
                          <div className="row">
                            <h4 className="mb0 market-color flex">
                              <img
                                className="mr5 wd-25"
                                src={Images?.coinLogo}
                              />{" "}
                              {threexAmount *
                                (isEarlyUserForWatchMinting
                                  ? EarlyMintWatchPoint
                                  : userDetails.userDetails.level)}
                            </h4>
                          </div>
                        </div>
                        <div className="p10">
                          <button
                            onClick={() => {
                              playClick();
                              setShowPopup(true);
                              setSelected({
                                booster: "3x",
                                ipl: true,
                                img: Images?.thirdXIplMarket,
                                price:
                                  threexAmount *
                                  (isEarlyUserForWatchMinting
                                    ? EarlyMintWatchPoint
                                    : userDetails.userDetails.level),
                              });
                            }}
                            type="button"
                            className="btn-card"
                          >
                            BUY
                          </button>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="row ipl1">
                    <div className="col-6">
                      <div className="market-card p5">
                        <div className="market-pick text-center">
                          <img
                            src={Images?.fourXIplMarket}
                            className="booster-margin"
                          />
                          <div className="row">
                            <h4 className="mb0 market-color flex">
                              <img
                                className="mr5 wd-25"
                                src={Images?.coinLogo}
                              />{" "}
                              {fourxAmount *
                                (isEarlyUserForWatchMinting
                                  ? EarlyMintWatchPoint
                                  : userDetails?.userDetails?.level)}
                            </h4>
                          </div>
                        </div>
                        <div className="p10">
                          <button
                            onClick={() => {
                              playClick();
                              setShowPopup(true);
                              setSelected({
                                booster: "4x",
                                ipl: true,
                                img: Images?.fourXIplMarket,
                                price:
                                  fourxAmount *
                                  (isEarlyUserForWatchMinting
                                    ? EarlyMintWatchPoint
                                    : userDetails?.userDetails?.level),
                              });
                            }}
                            type="button"
                            className="btn-card"
                          >
                            BUY
                          </button>
                        </div>
                      </div>
                    </div>
                    
                    <div className="col-6">
                      <div className="market-card p5">
                        <div className="market-pick text-center">
                          <img
                            src={Images?.fiveXIplAMarket}
                            className="booster-margin"
                          />
                          <div className="row">
                            <h4 className="mb0 market-color flex">
                              <img
                                className="mr5 wd-25"
                                src={Images?.coinLogo}
                              />{" "}
                              {fivexAmount *
                                (isEarlyUserForWatchMinting
                                  ? EarlyMintWatchPoint
                                  : userDetails.userDetails.level)}
                            </h4>
                          </div>
                        </div>
                        <div className="p10">
                          <button
                            onClick={() => {
                              playClick();
                              setShowPopup(true);
                              setSelected({
                                booster: "5x",
                                ipl: true,
                                img: Images?.fiveXIplAMarket,
                                price:
                                  fivexAmount *
                                  (isEarlyUserForWatchMinting
                                    ? EarlyMintWatchPoint
                                    : userDetails.userDetails.level),
                              });
                            }}
                            type="button"
                            className="btn-card"
                          >
                            BUY
                          </button>
                        </div>
                      </div>
                    </div>

                    {/* klads */}

                 
                  </div>
                  <div className="row ipl2"> 
                  <div className="col-6">
                      <div className="market-card p5">
                        <div className="market-pick text-center">
                          <img
                            src={Images?.fanRally}
                            className="booster-margin"
                          />
                          <div className="row">
                            <h4 className="mb0 market-color flex">
                              <img
                                className="mr5 wd-25"
                                src={Images?.coinLogo}
                              />{" "}
                              {RallyAmount *
                                (isEarlyUserForWatchMinting
                                  ? EarlyMintWatchPoint
                                  : userDetails.userDetails.level)}
                            </h4>
                          </div>
                        </div>
                        <div className="p10">
                          <button
                            onClick={() => {
                              playClick();
                              setShowPopup(true);
                              setSelected({
                                booster: "fanRally",
                                ipl: true,
                                img: Images?.fanRally,
                                price:
                                RallyAmount *
                                  (isEarlyUserForWatchMinting
                                    ? EarlyMintWatchPoint
                                    : userDetails.userDetails.level),
                              });
                            }}
                            type="button"
                            className="btn-card"
                          >
                            BUY
                          </button>
                        </div>
                      </div>

                    </div>
                    <div className="col-6">
                      <div className="market-card p5">
                        <div className="market-pick text-center">
                          <img
                            src={Images?.squadMultiplier}
                            className="booster-margin"
                          />
                          <div className="row">
                            <h4 className="mb0 market-color flex">
                              <img
                                className="mr5 wd-25"
                                src={Images?.coinLogo}
                              />{" "}
                              {squadMultiplierAmount *
                                (isEarlyUserForWatchMinting
                                  ? EarlyMintWatchPoint
                                  : userDetails.userDetails.level)}
                            </h4>
                          </div>
                        </div>
                        <div className="p10">
                          <button
                            onClick={() => {
                              playClick();
                              setShowPopup(true);
                              setSelected({
                                booster: "squadMultiplier",
                                ipl: true,
                                img: Images?.squadMultiplier,
                                price:
                                squadMultiplierAmount *
                                  (isEarlyUserForWatchMinting
                                    ? EarlyMintWatchPoint
                                    : userDetails.userDetails.level),
                              });
                            }}
                            type="button"
                            className="btn-card"
                          >
                            BUY
                          </button>
                        </div>
                      </div>
                      
                    </div>
                     </div>
                     <div className="row ipl3"> 
                  <div className="col-6">
                      <div className="market-card p5">
                        <div className="market-pick text-center">
                          <img
                            src={Images?.comboChain}
                            className="booster-margin"
                          />
                          <div className="row">
                            <h4 className="mb0 market-color flex">
                              <img
                                className="mr5 wd-25"
                                src={Images?.coinLogo}
                              />{" "}
                              {comboChaninAmout *
                                (isEarlyUserForWatchMinting
                                  ? EarlyMintWatchPoint
                                  : userDetails.userDetails.level)}
                            </h4>
                          </div>
                        </div>
                        <div className="p10">
                          <button
                            onClick={() => {
                              playClick();
                              setShowPopup(true);
                              setSelected({
                                booster: "comboChain",
                                ipl: true,
                                img: Images?.comboChain,
                                price:
                                comboChaninAmout *
                                  (isEarlyUserForWatchMinting
                                    ? EarlyMintWatchPoint
                                    : userDetails.userDetails.level),
                              });
                            }}
                            type="button"
                            className="btn-card"
                          >
                            BUY
                          </button>
                        </div>
                      </div>

                    </div>
          
                     </div>
                </div>
              )}

              {activeSection === "section2" && (
                <div className="scrollable-mrkt">
                  <div className="row mt15">
                    <div className="col-6">
                      <div className="market-card p5">
                        <div className="market-pick text-center">
                          <img
                            src="https://d1ccopf5cw1hft.cloudfront.net/s3data/boost-tap.png"
                            className="booster-margin"
                          />
                          <div className="row">
                            <h4 className="mb0 market-color flex">
                              <img
                                className="mr5 wd-25"
                                src={Images?.coinLogo}
                              />{" "}
                              {isEarlyUserForTapMinting ? "1000" : "5000"}
                            </h4>
                          </div>
                        </div>
                        <div className="p10">
                          <button
                            onClick={() => {
                              playClick();
                              setShowPopup(true);
                              setSelected({
                                booster: "tap",
                                img: "https://d1ccopf5cw1hft.cloudfront.net/s3data/boost-tap.png",
                                price: isEarlyUserForTapMinting ? 1000 : 5000,
                              });
                            }}
                            type="button"
                            className="btn-card"
                          >
                            BUY
                          </button>
                        </div>
                      </div>
                    </div>
                    <div className="col-6">
                      <div className="market-card p5">
                        <div className="market-pick text-center">
                          <img
                            src="https://d1ccopf5cw1hft.cloudfront.net/s3data/lighting.png"
                            className="booster-margin"
                          />
                          <div className="row">
                            <h4 className="mb0 market-color flex">
                              <img
                                className="mr5 wd-25"
                                src={Images?.coinLogo}
                              />{" "}
                              {720 *
                                (isEarlyUserForWatchMinting
                                  ? EarlyMintWatchPoint
                                  : userDetails.userDetails?.level)}
                            </h4>{" "}
                          </div>
                        </div>
                        <div className="p10">
                          <button
                            onClick={() => {
                              playClick();
                              setShowPopup(true);
                              setSelected({
                                booster: "5x",
                                img: "https://d1ccopf5cw1hft.cloudfront.net/s3data/lighting.png",
                                price:
                                  720 *
                                  (isEarlyUserForWatchMinting
                                    ? EarlyMintWatchPoint
                                    : userDetails.userDetails?.level),
                              });
                            }}
                            type="button"
                            className="btn-card"
                          >
                            BUY
                          </button>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="row">
                    <div className="col-6">
                      <div className="market-card p5">
                        <div className="market-pick text-center">
                          <img
                            src="https://d1ccopf5cw1hft.cloudfront.net/s3data/2booster.png"
                            className="booster-margin"
                          />
                          <div className="row">
                            <h4 className="mb0 market-color flex">
                              <img
                                className="mr5 wd-25"
                                src={Images?.coinLogo}
                              />{" "}
                              {96 *
                                (isEarlyUserForWatchMinting
                                  ? EarlyMintWatchPoint
                                  : userDetails?.userDetails?.level)}
                            </h4>
                          </div>
                        </div>
                        <div className="p10">
                          <button
                            onClick={() => {
                              playClick();
                              setShowPopup(true);
                              setSelected({
                                booster: "2x",
                                img: "https://d1ccopf5cw1hft.cloudfront.net/s3data/2booster.png",
                                price:
                                  96 *
                                  (isEarlyUserForWatchMinting
                                    ? EarlyMintWatchPoint
                                    : userDetails?.userDetails?.level),
                              });
                            }}
                            type="button"
                            className="btn-card"
                          >
                            BUY
                          </button>
                        </div>
                      </div>
                    </div>
                    <div className="col-6">
                      <div className="market-card p5">
                        <div className="market-pick text-center">
                          <img
                            src="https://d1ccopf5cw1hft.cloudfront.net/s3data/threex.png"
                            className="booster-margin"
                          />
                          <div className="row">
                            <h4 className="mb0 market-color flex">
                              <img
                                className="mr5 wd-25"
                                src={Images?.coinLogo}
                              />{" "}
                              {288 *
                                (isEarlyUserForWatchMinting
                                  ? EarlyMintWatchPoint
                                  : userDetails.userDetails.level)}
                            </h4>
                          </div>
                        </div>
                        <div className="p10">
                          <button
                            onClick={() => {
                              playClick();
                              setShowPopup(true);
                              setSelected({
                                booster: "3x",
                                img: "https://d1ccopf5cw1hft.cloudfront.net/s3data/threex.png",
                                price:
                                  288 *
                                  (isEarlyUserForWatchMinting
                                    ? EarlyMintWatchPoint
                                    : userDetails.userDetails.level),
                              });
                            }}
                            type="button"
                            className="btn-card"
                          >
                            BUY
                          </button>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              )}
            </div>
          </div>
        </div>
        {showPopup && (
          <div className="popup">
            <div className="popup-content">
              <>
                <h2 className="epic-m txt-color">{selected.booster} Booster</h2>
                <img
                  src="https://d1ccopf5cw1hft.cloudfront.net/s3data/Xicon.png"
                  className="cancel-img"
                  onClick={() => {
                    closePopUp();
                  }}
                />
                <div className="row text-center">
                  <div className="col-12">
                    <div className="epic-market">
                      {/* {selectedCard && ( */}
                      <img
                        src={selected?.img}
                        alt={"booster"}
                        className="booster1"
                      />
                      {/* )} */}
                      {/* <h3 className="rw-popup">You got 2x!</h3> */}
                      <div>
                        <div className="buttons">
                          <button
                            className="decre txt-color"
                            onClick={handleClick2}
                          >
                            <p className="txt-color mb0">-</p>
                          </button>
                          <div>
                            <p className="count">{count}</p>
                          </div>
                          <button className="decre" onClick={handleClick1}>
                            <p className="txt-color mb0">+</p>
                          </button>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <button
                  onClick={purchaseCards}
                  className="btn-reward1"
                  style={err === "" ? {} : { color: "white" }}
                  disabled={isLoading}
                >
                  {isLoading ? (
                    <div className="loader-spin">
                      <div className="spinner"></div>{" "}
                    </div>
                  ) : // Add your spinner here
                  err === "" ? (
                    selected.price * count
                  ) : (
                    "Not Enough Total Tokens!"
                  )}
                </button>
                {/* <button className="btn-reward">Free Pick</button> */}
              </>
            </div>
          </div>
        )}
      </div>
    </div>
  );
};
export default MarketPlace;
